import { useNavigate } from '@solidjs/router'
import { Component, createSignal } from 'solid-js'
import { parse } from 'valibot'
import { backendAxios } from '../../axios'
import AlertBag from '../../components/AlertBag'
import Loader from '../../components/Loader'
import { createAlertBagStore, setAlertBagError, setAlertBagSuccess } from '../../rx/store/AlertBag'
import { StoreLobbyBodySchema } from '../../backend_schemas'

const CreateLobbyPage: Component = () => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = createSignal<boolean>(false)
  const alertBag = createAlertBagStore()

  const handleCreate = async (e: Event) => {
    e.preventDefault()
    setIsLoading(true)
    setAlertBagError(alertBag, null)
    try {
      const payload = { dname: 'test', bio: null, passphrase: null, map_id: 1 }
      const validated = parse(StoreLobbyBodySchema, payload)
      const response = await backendAxios.post('/st1/lobby', validated)
      setAlertBagSuccess(alertBag, 'Lobby created successfully')
      navigate(`/lobby/${response.data.id}`)
    } catch (err) {
      setAlertBagError(alertBag, err as Error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div class="container mt-5">
      <h2>Create Lobby</h2>
      <AlertBag store={alertBag} />
      <form onSubmit={handleCreate}>
        <button type="submit" class="btn btn-primary" disabled={isLoading()}>
          {isLoading() ? <Loader /> : 'Create Lobby'}
        </button>
      </form>
    </div>
  )
}

export default CreateLobbyPage
